import { DUEL_CARD_DEFINITIONS } from '@flip7/shared';
import type { DuelCardType } from '@flip7/shared';

interface DuelCardProps {
  cardType: DuelCardType;
  compact?: boolean;
  onClick?: () => void;
  selected?: boolean;
  disabled?: boolean;
}

const CATEGORY_COLORS = {
  action: '#C62828',
  perk: '#6A1B9A',
};

const CATEGORY_BG = {
  action: 'linear-gradient(180deg, #1C1018 0%, #14101A 100%)',
  perk: 'linear-gradient(180deg, #18141C 0%, #12101A 100%)',
};

export function DuelCard({ cardType, compact, onClick, selected, disabled }: DuelCardProps) {
  const def = DUEL_CARD_DEFINITIONS[cardType];
  if (!def) return null;

  const color = CATEGORY_COLORS[def.category];

  if (compact) {
    return (
      <button
        className={`duel-card duel-card--compact${selected ? ' duel-card--selected' : ''}${disabled ? ' duel-card--disabled' : ''}`}
        onClick={onClick}
        disabled={disabled}
        style={{ '--duel-card-color': color, background: CATEGORY_BG[def.category] } as React.CSSProperties}
      >
        <span className="duel-card__icon">{def.icon}</span>
        <span className="duel-card__name">{def.name}</span>
        <span className="duel-card__badge">{def.category}</span>
      </button>
    );
  }

  return (
    <button
      className={`duel-card${selected ? ' duel-card--selected' : ''}${disabled ? ' duel-card--disabled' : ''}`}
      onClick={onClick}
      disabled={disabled}
      style={{ '--duel-card-color': color, background: CATEGORY_BG[def.category] } as React.CSSProperties}
    >
      <div className="duel-card__top-bar" />
      <span className="duel-card__icon">{def.icon}</span>
      <span className="duel-card__name">{def.name}</span>
      <div className="duel-card__divider" />
      <span className="duel-card__desc">{def.description}</span>
      <span className="duel-card__badge">{def.category}</span>
    </button>
  );
}
